import React, { useState, useEffect } from 'react'
import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle,Modal,
} from '@material-ui/core';
import styles from './WorkoutLog.module.css'
import { useHistory, } from 'react-router-dom';

import { rwbApi } from '../../../../shared/apis/api';

import { PROFILE_TAB_LABELS } from '../../../../shared/constants/Labels';
import WorkoutCard from './WorkoutCard.react';

import { MdAdd as AddIcon } from 'react-icons/md';
import { hoursMinutesSecondsFromMinutes } from '../../../../shared/utils/ChallengeHelpers';
import Header from '../Header';
import CreatePost from '../feed/CreatePost';
import { CHALLENGE_TYPES } from '../../../../shared/constants/ChallengeTypes';
import AddHydrationModal from '../challenges/AddHyrationModal.react';
import RWBModal from '../RWBModal.web';

export default function WorkoutLog() {

  const [workoutData, setWorkoutData] = useState([]);
  const [optionsOverlayVisible,setOptionsOverlayVisible ] = useState(false);
  const [selectedElementIndex, setSelectedElementIndex] = useState(null);
  const [openDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showWorkoutModal, setShareWorkoutModal]= useState(false);
  const [showHydrationModal, setShowHydrationModal] = useState(false);

  const history = useHistory();
  useEffect(() => {
    fetchUserWorkout()
  }, [])

  const fetchUserWorkout = () => {
    const type = history?.location?.state?.type;
    const challengeId = history?.location?.state?.challengeId;
    rwbApi
      .getUserWorkouts(challengeId, type)
      .then((workouts) => {
        setWorkoutData(workouts.data)
      })
      .catch((err) => {
        // errorAlert(CHALLENGE_ERRORS.LOADING_WORKOUTS);
      })
      
  }

  const toggleOverlay = (index) => {
    setSelectedElementIndex(index);
    setOptionsOverlayVisible(!optionsOverlayVisible);
  };
 const  deleteWorkout = () => {
      rwbApi
        .deleteWorkout(workoutData[selectedElementIndex].id)
        .then(() => {
          setOptionsOverlayVisible(!optionsOverlayVisible);
          setShowDeleteDialog(false)
          fetchUserWorkout();
        })
        .catch((err) => {
          alert(err)
        });
  };
 const handlePostShareWorkout = () =>{
       setOptionsOverlayVisible(!optionsOverlayVisible);
       setShareWorkoutModal(false)
 }
  return (
    <>
    <div>
       <Header title={history?.location?.state?.type === CHALLENGE_TYPES.hydration ? 'Activity' : PROFILE_TAB_LABELS.CHALLENGE_WORKOUT_LOGS} onBack={() => history.goBack()} />
    
    <div className={[styles.container]}>
     
      <div className={[styles.content]}>
        {workoutData.length > 0 ? workoutData.map((item, index) => {
          return <WorkoutCard
            key={index}
            miles={item.miles}
            steps={item.steps}
            hours={hoursMinutesSecondsFromMinutes(item.minutes).hours}
            minutes={hoursMinutesSecondsFromMinutes(item.minutes).minutes}
            seconds={hoursMinutesSecondsFromMinutes(item.minutes).seconds}
            onDelete={() => {setShowDeleteDialog(true) }}
            onShare={() => {setShareWorkoutModal(true) }}
            workoutDate={item.entry_date}
            workoutDateTime={item.entry_datetime}
            workoutData={workoutData}
            optionsOverlayVisible={optionsOverlayVisible && selectedElementIndex === index}
            setOptionsOverlayVisible={setOptionsOverlayVisible}
            toggleOverlay={() => toggleOverlay(index)}
            ounces_of_water={item.ounces_of_water}
          />
        }) : null}

      </div>
      <div
        className={[styles.floatingBtnContainer]}
        onClick={() => {
          history?.location?.state?.type === CHALLENGE_TYPES.hydration
          ? setShowHydrationModal(true)
          : history.push(`/recordworkout`)
        }}>
        <AddIcon className={[styles.addIcon]} />
      </div>

      <Dialog open={openDeleteDialog} onClose={()=>{setShowDeleteDialog(false)}}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        Are you sure you want to delete workout?
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{setShowDeleteDialog(false)}} color="primary">
          Cancel
        </Button>
        <Button onClick={()=>deleteWorkout()} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>

   
    </div>
    <div className={[styles.createPostContainer]}>
    {showWorkoutModal &&
      <CreatePost 
            type={'user'}
            eventStartTime={workoutData[selectedElementIndex].entry_date}
            workOutId={workoutData[selectedElementIndex].id}
            miles={workoutData[selectedElementIndex].miles}
            steps={workoutData[selectedElementIndex].steps}
            hours={hoursMinutesSecondsFromMinutes(workoutData[selectedElementIndex].minutes).hours}
            minutes={hoursMinutesSecondsFromMinutes(workoutData[selectedElementIndex].minutes).minutes}
            seconds={hoursMinutesSecondsFromMinutes(workoutData[selectedElementIndex].minutes).seconds}
            mergeNewPost={()=>{}}
            closeModalHandler={()=>{
              handlePostShareWorkout()
            }
            }
      />
    }
    <RWBModal bottomSheet={true} open={showHydrationModal} onClose={() => setShowHydrationModal(false)}>
      <AddHydrationModal 
        onRequestClose={() => setShowHydrationModal(false)}
      />
    </RWBModal>
    </div>
    </div>
    
    </>
  )
}
